export default "__VITE_ASSET__BfiSjOJK__"